import React from 'react'

const RightArrow = props => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30.000000pt" height="30.000000pt" viewBox="0 0 203.000000 203.000000" preserveAspectRatio="xMidYMid meet" {...props}>
    <g transform="translate(0.000000,203.000000) scale(0.100000,-0.100000)" fill="#909090" stroke="none">
      <path d="M1610 1280 l0 -80 -805 0 -805 0 0 -185 0 -185 805 0 805 0 0 -80 c0 -44 3 -80 6 -80 4 0 358 294 401 334 10 9 -34 51 -192 184 -112 94 -207 172 -210 172 -3 0 -5 -36 -5 -80z"/>
    </g>
  </svg>
)

export default RightArrow;
